import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/** Checkout de ImpulTienda. */
const CHECKOUT_URL = 'https://acro-yoga-class-ready.impultienda.ar/checkout';
const included = ['6 complete volumes, 300 pages', '60 ready-to-teach sessions (S01–S60)', '24 printable worksheets', '5 instant-use bonuses', 'Every skill in 3 lanes: Ground, Lift, Fly', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="arcs-light w-full bg-sand-dark text-night" data-id="element-223" data-mp="1ruja7z0plmvc">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-224" data-mp="20sli8yiv1fs4">
        <div className="text-center" data-id="element-225" data-mp="20v7ql0dkrzbe">
          <p className="eyebrow text-coral-deep" data-id="element-226" data-mp="3h6v5fpbd8yhd">Complete package</p>
          <h2 id="pricing-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-night sm:text-5xl" data-id="element-227" data-mp="3h97ns3l1dauy">
            Every class you need for the whole year
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-[28px] border border-sand-dark bg-white shadow-card" data-id="element-228" data-mp="4s49x6ox4jfs">
          <div className="bg-night px-5 py-5 text-center" data-id="element-229" data-mp="9tjw522u0vzr">
            <h3 className="font-display text-xl text-sand sm:text-2xl" data-id="element-230" data-mp="er1vq1uylyv3">
              Acro Yoga Class Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-coral" data-id="element-231" data-mp="3daa43mhz5j43">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-232" data-mp="3i5picfjw9h11">
            <div className="rounded-3xl bg-night-deep px-3 pb-4 pt-5" data-id="element-233" data-mp="3n6vbgehgv6b3">
              <ProductStack data-id="element-234" data-mp="3rxv9jn2bnuf6" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-235" data-mp="3ryn3ktg9tk3c">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-236" data-mp="2uhy6fd29n60a">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-ground-soft" data-id="element-237" data-mp="2zgiuyf85o18w">
                    <CheckIcon className="h-3 w-3 text-ground-deep" aria-hidden="true" data-id="element-238" data-mp="2rf1us36q3k7u" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-sand-dark pt-6 text-center" data-id="element-239" data-mp="3164q0ocz14z7">
              <p className="text-[13px] text-night-soft" data-id="element-240" data-mp="2w8mkl7y5x7vy">
                Regular price{' '}
                <span className="text-night-muted line-through" data-id="element-241" data-mp="28j1xqdyw1qhe">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-242" data-mp="23jp85lgmu5b4">
                <span className="mt-2.5 font-display text-3xl" data-id="element-243" data-mp="2ifwx0z2zjuwq">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-244" data-mp="2ie3p7ggmz4n5">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-night-muted" data-id="element-245" data-mp="3tv3dm0zv4zbw">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-246" data-mp="3ovqrjigtfwad">
                <span className="rounded-full border border-coral bg-coral px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest text-night" data-id="element-247" data-mp="a42rp0cwqnv">
                  Save $42
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-night-soft" data-id="element-248" data-mp="3ng4upzma2kw4">
                  One-time payment
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-night-soft" data-id="element-249" data-mp="j1wn6v1d13jz">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-night-soft" data-id="element-250" data-mp="a8b7n9hdfi9i">
                That&apos;s less than 50¢ a session.
              </p>

              <CtaButton href={CHECKOUT_URL} target="_top" className="mt-4" data-id="element-251" data-mp="11zr5jzodorf1">
                Get Acro Yoga Class Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-night-muted" data-id="element-252" data-mp="16s0pmz2tax9e">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-bold text-night-soft" data-id="element-253" data-mp="3a8fdyixsfidy">
                <li className="flex items-center gap-1.5" data-id="element-254" data-mp="3592veady8xh6">
                  <LockIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-255" data-mp="359m8ndsnmxov" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-256" data-mp="1scf92onl41r">
                  <ZapIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-257" data-mp="1uqb3dr5qkad" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-258" data-mp="3o7oszfa9c6gc">
                  <ShieldCheckIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-259" data-mp="3o63xnng4cjhf" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-night-muted" data-id="element-260" data-mp="kkybho3h2wmv">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}